import { WorkSessionBanner } from '../../features/work-session'
import { WorkerCalendarWidget, useWorkerCalendarDays } from '../../widgets/worker-calendar'

export const WorkerCalendarPage = () => {
  const calendar = useWorkerCalendarDays()

  // `min-h-0` so the widget's own flex column can shrink below the 1536px grid it contains and
  // scroll internally, instead of overflowing this page and the layout pane above it.
  return (
    <div className="h-full min-h-0 flex flex-col overflow-hidden">
      <WorkSessionBanner />
      <WorkerCalendarWidget calendar={calendar} />
    </div>
  )
}
